import createAction from '@clearscore/helpers.create-action';
import createRequestPayload from '@clearscore/helpers.create-request-payload';
import getEnv from '@clearscore/helpers.envs';
import getDevice from '@clearscore/helpers.device';
import { getAnonymousId } from '@clearscore/helpers.segment';

import {
    SET_SESSION,
    LOGIN_SUBMIT,
    LOGIN_OAUTH_AUTHORISE,
    LOGIN_OAUTH_SUBMIT,
    TIMEOUT_SUCCESS,
    LOGOUT_SUBMIT,
    CLEAR_SESSION,
    SET_USER_ROLE,
    LOGIN_OAUTH_REFRESH,
    NATIVE_SET_SESSION,
} from './session.types';
/*
 * Send action for global login
 *
 * @param {Object} data - object containing required properties
 * @param {String} data.email - users uuid
 * @param {String} data.password - users password
 * @todo: remove conditional when oAuth is out
 */
export const login = (data, meta) =>
    getEnv('OAUTH_ENABLED')
        ? createAction(
              LOGIN_OAUTH_SUBMIT,
              createRequestPayload(
                  'international',
                  '/login-service/v3/authorise',
                  'post',
                  {
                      response_type: 'code', // its always code
                      client_type: 'internal', // its always internal
                      client_id: getEnv('OAUTH_CLIENT_ID'),
                      device_id: getDevice.DEVICE_ID.hash,
                      device_type: getDevice(), // Desktop
                      device_name: getDevice.DEVICE_NAME, // Browser Name
                      refresh_token_ttl: getEnv('OAUTH_REFRESH_TLL'), // default life of refresh token
                      ...data,
                  },
                  meta,
              ),
          )
        : createAction(LOGIN_SUBMIT, createRequestPayload('international', '/login-service/v2/sign-in', 'post', data));

/*
 * Auth code for a refresh_token and session_token
 *
 * @param {Object} data - object containing required properties
 * @param {String} data.email - users uuid
 * @param {String} data.password - users password
 */
export const authorise = (data, meta) =>
    createAction(
        LOGIN_OAUTH_AUTHORISE,
        createRequestPayload(
            'international',
            '/login-service/v3/token',
            'post',
            {
                grant_type: 'authorization_code',
                client_type: 'internal',
                client_id: getEnv('OAUTH_CLIENT_ID'),
                device_id: getDevice.DEVICE_ID.hash,
                session_id: getAnonymousId(),
                ...data,
            },
            meta,
        ),
    );

/*
 * Refresh oauth tokens
 *
 * @param {Object} data - object containing required properties
 */
export const refreshToken = (data, meta) =>
    createAction(
        LOGIN_OAUTH_REFRESH,
        createRequestPayload(
            'international',
            '/login-service/v3/token',
            'post',
            {
                grant_type: 'refresh_token',
                client_type: 'internal',
                client_id: getEnv('OAUTH_CLIENT_ID'),
                device_id: getDevice.DEVICE_ID.hash,
                session_id: getAnonymousId(),
                ...data,
            },
            meta,
        ),
    );

/*
 * Manually set the session data
 *
 * @param {string} data.accountId - users uuid
 * @param {string} data.sessionToken - unique session token
 */
export const setSession = (data) =>
    createAction(SET_SESSION, { accountId: '', sessionToken: data.accessToken || data.access_token || '', ...data });

/*
 * Manually set the native session, we should never listen to this action
 *
 * @param {string} data.accountId - users uuid
 * @param {string} data.sessionToken - unique session token
 */
export const setNativeSession = (data) =>
    createAction(NATIVE_SET_SESSION, {
        accountId: '',
        sessionToken: data.accessToken || data.access_token || '',
        ...data,
    });

export const timeout = () => createAction(TIMEOUT_SUCCESS);
export const clearSession = () => createAction(CLEAR_SESSION);

export const logout = () =>
    getEnv('OAUTH_ENABLED')
        ? createAction(LOGOUT_SUBMIT, createRequestPayload('international', '/login-service/v3/logout', 'post', {}))
        : createAction(LOGOUT_SUBMIT);

export const setUserRole = ({ role }) => createAction(SET_USER_ROLE, { role });
